export const BASE = `/private`;
const SETTINGS_BASE = `${BASE}/settings`;
export const FOLDER_BASE = '/folders';
export const TEST_CASE_BASE = '/test_cases';
export const DATA_CLEAN_UP_BASE = `${BASE}/tags`;
export const LINKED_ENTITIES = `${BASE}/tag_uses`;
export const SAVE_POINT_BASE = '/versioning/save_points';
export const PREVIEW_BASE = '/savepoint';
export const AUDIT_LOGIN_URL = '/audit/login';
export const WINDOWS_DESKTOP = `${BASE}/elements`;
const ACCESSIBILITY_TESTING = `${BASE}/accessibility_test`;
export const PrivateURLConstants = {
  ELEMENT_LIST: `${WINDOWS_DESKTOP}/windows_elements`,
  ELEMENT_LIST_UPDATE: `${WINDOWS_DESKTOP}/windows_element`,
  ENVIRONMENTS: `${BASE}/environments`,
  VARIABLES: `${BASE}/environments/variables`,
  UPLOADS: `${BASE}/uploads`,
  CUSTOM_FIELDS: `${SETTINGS_BASE}/custom_fields`,
  PHONE_NUMBERS: `${BASE}/phone_numbers`,
  STEP_RUNTIME_VARIABLES: `${BASE}/step_runtime_variables`,
  PERMISSION_ENTITIES: `${BASE}/permission_entities`,
  INTEGRATIONS: `${SETTINGS_BASE}/external_application_configs`,
  API_KEYS: `${SETTINGS_BASE}/api_keys`,
  PHONENUMBER: `${BASE}/phone_numbers`,
  KIBBUTZ: `${BASE}/kibbutz`,
  MAIL_BOXES: `${BASE}/mail_boxes`,
  MAIL_BOX: `${BASE}/mail_boxes`,
  TUNNEL: `${BASE}/connect_tunnels`,
  MAIL_BOX_MESSAGE: `${BASE}/mail_box_messages`,
  INVOICE: `${BASE}/invoice`,
  BILLING: `${BASE}/billing`,
  CASE: `${BASE}/test_cases`,
  STEP: `${BASE}/test_steps`,
  NLP_TEMPLATE: `${BASE}/nlp_templates`,
  UPLOAD_VERSIONS: `${BASE}/upload_versions`,
  TEST_CASE_FILTERS: `${BASE}/test_case_filters`,
  TEST_CASE_TAGS: `${BASE}/test_case_tags`,
  STEP_GROUP_FILTERS: `${BASE}/step_group_filters`,
  API_STEPS: `${BASE}/api_steps`,
  API_STEP_RESULTS: `${BASE}/api_step_results`,
  STORED_OBJECTS: `${BASE}/stored_objects`,
  BULK_ACTIONS: `${BASE}/bulk_actions`,
  COMMENTS: `${BASE}/comments`,
  CUSTOM_FUNCTIONS: `${BASE}/custom_functions`,
  DATA_GENERATORS: `${BASE}/data_generators`,
  DOWNLOADS: `${BASE}/downloads`,
  RECORDER_SCREENSHOT: `${BASE}/recorder_screenshot`,
  ELEMENTS: `${BASE}/elements`,
  ELEMENT_FILETERS: `${BASE}/element_filters`,
  ELEMENTS_TAGS: `${BASE}/element_tags`,
  ELEMENTS_SCREEN_NAME: `${BASE}/element_screen_name`,
  FILE_UPLOADS: `${BASE}/file_uploads`,
  HELP_PREFERENCES: `${BASE}/help_preferences`,
  REVIEW_COMMENTS: `${BASE}/review_comments`,
  TEST_DATA: `${BASE}/test_data`,
  TEST_DATA_SETS: `${BASE}/test_data_sets`,
  APPLICATIONS: `${BASE}/applications`,
  VERSIONS: `${BASE}/application_versions`,
  PROJECTS: `${BASE}/projects`,
  USER_PREFERENCES: `${BASE}/user_preferences`,
  USER_PROJECT_MAPPING: `${BASE}/user_project_mappings`,
  REQUIREMENT_TYPES: `${BASE}/requirement_types`,
  REQUIREMENTS: `${BASE}/requirements`,
  TEST_CASE_TYPES: `${BASE}/test_case_types`,
  TEST_CASE_PRIORITIES: `${BASE}/test_case_priorities`,
  USERS: `${BASE}/settings/users`,
  PENDING_REQUESTS: `${BASE}/join_requests`,
  FEATURES: `${FOLDER_BASE}/features`,
  TEST_CASES: `${FOLDER_BASE}${TEST_CASE_BASE}`,
  SCENARIO: `${FOLDER_BASE}/scenarios`,
  MOVE_SCENARIO: `${FOLDER_BASE}/move`,
  MOVE_TESTCASE: `${FOLDER_BASE}${TEST_CASE_BASE}/move`,
  BULK_MOVE_TESTCASE: `${FOLDER_BASE}${TEST_CASE_BASE}/bulk_move`,
  EXECUTION_RESULTS: `${BASE}/execution_results`,
  TEST_CASE_RESULTS: `${BASE}/test_case_results`,
  AUTO_HEAL: `${BASE}/auto_heal`,
  TEST_SUITE_RESULTS: `${BASE}/test_suite_results`,
  ENVIRONMENT_RESULTS: `${BASE}/environment_results`,
  TEST_PLAN_HOOK_RESULTS: `${BASE}/test_plan_hook_result`,
  TEST_CASE_DATA_DRIVEN_RESULTS: `${BASE}/test_case_data_driven_results`,
  TEST_STEP_RESULTS: `${BASE}/test_step_results`,
  TEST_STEP_RETRY_RESULTS: `${BASE}/test_step_retry_results`,
  SCREENSHOT_COMPARISONS: `${BASE}/screenshot_comparisons`,
  ARTEFACTS: `${BASE}/artefacts`,
  EXPORT: `${BASE}/exports`,
  SUITE_TEST_CASE_MAPPINGS: `${BASE}/suite_test_cases_mappings`,
  FIGMA_BASE_IMAGE: `${BASE}/design_asset`,
  TEST_SUITES: `${BASE}/test_suites`,
  URL_BASED_ACCESSIBILITY_TESTING: `${ACCESSIBILITY_TESTING}/url_based`,
  STEP_LEVEL_ACCESSIBILITY_TESTING: `${ACCESSIBILITY_TESTING}/step_level`,
  AI_WORKFLOW: `${BASE}/ai-workflow`,
  AI_ACTIVITY_LOG: `${BASE}/ai-activity-log`,
  TESTSIGMA_IP_INFO: `${SETTINGS_BASE}/ip_info`,
  ATTO_SESSIONS: `${BASE}/atto-sessions`,
  ATTO_TEST_CASES: `${BASE}/atto-test-cases`,
  ATTO_PREVIOUS_TEST_CASE: `/alpha/atto/test-case`,
  ATTO_SCENARIOS: `${BASE}/atto-scenarios`,
};

export const AUDIT_LOGS_USERS_URL = `${PrivateURLConstants.USERS}?query=type!API_USER&size=10000`;
